import { alpha, createTheme, type ThemeOptions } from "@mui/material";

import { SECONDARY_COLORS } from "./palette";

const defaultTheme = createTheme();

const customShadows: ThemeOptions["shadows"] = [...defaultTheme.shadows];

// Shadow definitions based on design system
customShadows[1] = `0px 1px 3px 0px ${alpha(
  SECONDARY_COLORS[200],
  0.12,
)}, 0px 1px 1px 0px ${alpha(
  SECONDARY_COLORS[200],
  0.14,
)}, 0px 2px 1px -1px ${alpha(SECONDARY_COLORS[200], 0.2)}`;

customShadows[2] = `0px 1px 5px 0px ${alpha(
  SECONDARY_COLORS[200],
  0.12,
)}, 0px 2px 2px 0px ${alpha(
  SECONDARY_COLORS[200],
  0.14,
)}, 0px 3px 1px -2px ${alpha(SECONDARY_COLORS[200], 0.2)}`;

customShadows[3] = `0px 1px 8px 0px ${alpha(
  SECONDARY_COLORS[200],
  0.12,
)}, 0px 3px 4px 0px ${alpha(
  SECONDARY_COLORS[200],
  0.14,
)}, 0px 3px 3px -2px ${alpha(SECONDARY_COLORS[200], 0.2)}`;

customShadows[4] = `0px 1px 10px 0px ${alpha(
  SECONDARY_COLORS[200],
  0.12,
)}, 0px 4px 5px 0px ${alpha(
  SECONDARY_COLORS[200],
  0.14,
)}, 0px 2px 4px -1px ${alpha(SECONDARY_COLORS[200], 0.2)}`;

customShadows[5] = `0px 1px 14px 0px ${alpha(
  SECONDARY_COLORS[200],
  0.12,
)}, 0px 5px 8px 0px ${alpha(
  SECONDARY_COLORS[200],
  0.14,
)}, 0px 3px 5px -1px ${alpha(SECONDARY_COLORS[200], 0.2)}`;

customShadows[6] = `0px 1px 18px 0px ${alpha(
  SECONDARY_COLORS[200],
  0.12,
)}, 0px 6px 10px 0px ${alpha(
  SECONDARY_COLORS[200],
  0.14,
)}, 0px 3px 5px -1px ${alpha(SECONDARY_COLORS[200], 0.2)}`;

customShadows[7] = `0px 2px 16px -1px ${alpha(
  SECONDARY_COLORS[200],
  0.12,
)}, 0px 7px 10px 1px ${alpha(
  SECONDARY_COLORS[200],
  0.14,
)}, 0px 4px 5px -2px ${alpha(SECONDARY_COLORS[200], 0.2)}`;

customShadows[8] = `0px 3px 14px 2px ${alpha(
  SECONDARY_COLORS[200],
  0.12,
)}, 0px 8px 10px 1px ${alpha(
  SECONDARY_COLORS[200],
  0.14,
)}, 0px 5px 5px -3px ${alpha(SECONDARY_COLORS[200], 0.2)}`;

customShadows[9] = `0px 3px 16px 2px ${alpha(
  SECONDARY_COLORS[200],
  0.12,
)}, 0px 9px 12px 1px ${alpha(
  SECONDARY_COLORS[200],
  0.14,
)}, 0px 5px 6px -3px ${alpha(SECONDARY_COLORS[200], 0.2)}`;

customShadows[10] = `0px 4px 18px 3px ${alpha(
  SECONDARY_COLORS[200],
  0.12,
)}, 0px 10px 14px 1px ${alpha(
  SECONDARY_COLORS[200],
  0.14,
)}, 0px 6px 6px -3px ${alpha(SECONDARY_COLORS[200], 0.2)}`;

customShadows[11] = `0px 4px 20px 3px ${alpha(
  SECONDARY_COLORS[200],
  0.12,
)}, 0px 11px 15px 1px ${alpha(
  SECONDARY_COLORS[200],
  0.14,
)}, 0px 6px 7px -4px ${alpha(SECONDARY_COLORS[200], 0.2)}`;

customShadows[12] = `0px 5px 22px 4px ${alpha(
  SECONDARY_COLORS[200],
  0.12,
)}, 0px 12px 17px 2px ${alpha(
  SECONDARY_COLORS[200],
  0.14,
)}, 0px 7px 8px -4px ${alpha(SECONDARY_COLORS[200], 0.2)}`;

customShadows[13] = `0px 5px 24px 4px ${alpha(
  SECONDARY_COLORS[200],
  0.12,
)}, 0px 3px 19px 2px ${alpha(
  SECONDARY_COLORS[200],
  0.14,
)}, 0px 7px 8px -4px ${alpha(SECONDARY_COLORS[200], 0.2)}`;

customShadows[14] = `0px 5px 26px 4px ${alpha(
  SECONDARY_COLORS[200],
  0.12,
)}, 0px 14px 21px 2px ${alpha(
  SECONDARY_COLORS[200],
  0.14,
)}, 0px 7px 9px -4px ${alpha(SECONDARY_COLORS[200], 0.2)}`;

customShadows[15] = `0px 6px 28px 5px ${alpha(
  SECONDARY_COLORS[200],
  0.12,
)}, 0px 15px 22px 2px ${alpha(
  SECONDARY_COLORS[200],
  0.14,
)}, 0px 8px 9px -5px ${alpha(SECONDARY_COLORS[200], 0.2)}`;

customShadows[16] = `0px 6px 30px 5px ${alpha(
  SECONDARY_COLORS[200],
  0.12,
)}, 0px 16px 24px 2px ${alpha(
  SECONDARY_COLORS[200],
  0.14,
)}, 0px 8px 10px -5px ${alpha(SECONDARY_COLORS[200], 0.2)}`;

export const CUSTOM_SHADOWS = customShadows;
